module.exports = __webpack_public_path__ + "files/a4baf3534ad0a40c5a315c619b76cdb8.png";